import { useRouteError } from 'react-router';
import { useLogout } from '@/shared/hooks';
import { useEffect } from 'react';
import { getHistoryTree } from '@/app/routers/history-store/history-tree-store';
import useCampaignCreationStore from '@/features/campaign-creation/model/store';
import { useInviteLinksStore } from '@/features/analytics/model';
import { useQueryClient } from '@tanstack/react-query';
export const RootErrorBoundary = () => {
  const logout = useLogout();
  const exception = useRouteError();

  const queryClient = useQueryClient();
  const { resetForm } = useCampaignCreationStore();
  const { resetInviteLinks } = useInviteLinksStore();

  useEffect(() => {
    console.error('Unhandled error (RootErrorBoundary):', exception);

    try {
      resetForm();
    } catch (_error: unknown) {
      //
    }

    try {
      resetInviteLinks();
    } catch (_error: unknown) {
      //
    }

    try {
      getHistoryTree().reset();
    } catch (_error: unknown) {
      //
    }

    localStorage.clear();
    queryClient.clear();
  }, [exception, queryClient, resetForm, resetInviteLinks]);

  return (
    <div role="alert" className="fallback">
      <h1 className="fallback__img">Что-то пошло не так(</h1>
      <p className="fallback__link" onClick={logout}>
        Если нажать сюда и залогиниться заново, то скорее всего все заработает
      </p>
    </div>
  );
};
